module.exports = __webpack_public_path__ + "static/media/spesa.64f99efe.jpg";